export default "__VITE_ASSET__D$pca$Z9__"